export default __webpack_public_path__ + "static/media/V385_RoHS.c8ce30f0.pdf";